export default __webpack_public_path__ + "static/media/About-Tower-viajes-1@2x.bda13e37.jpg";